import type { IconData } from '@stacksjs/iconify-core'

export const gamepadRetro: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 5h1a1 1 0 1 1 0 2H7v1a1 1 0 1 1-2 0V7H4a1 1 0 1 1 0-2h1V4a1 1 0 1 1 2 0zM6 0h12a6 6 0 1 1-4.472 10h-3.056A6 6 0 1 1 6 0m0 2a4 4 0 1 0 2.982 6.666L9.578 8h4.844l.596.666A4 4 0 1 0 18 2zm12 3a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-2 2a1 1 0 1 1 0-2a1 1 0 0 1 0 2m4 0a1 1 0 1 1 0-2a1 1 0 0 1 0 2m-2 2a1 1 0 1 1 0-2a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default gamepadRetro
